import React, { useState } from "react";
import { Checkbox } from "antd";
import { ICellRendererParams } from "ag-grid-community";
import { oc } from "ts-optchain";

import { useAlertUpdate } from "./hooks";
import { useRootSelector } from "@/infrastructure/hooks";
import { FireSel } from "@/features/firestore";

export default () => {
  // Higher order function: as ag-grid frameworkComponents is not able to access redux
  const { userAlertLimit, updateAlertLimit } = useAlertUpdate();
  const exchangeCountryMap = useRootSelector(FireSel.exchangeCountryMap)

  return (params: ICellRendererParams) => {
    const [isCheck, setIsCheck] = useState<boolean>(params.value);

    return <Checkbox onChange={onChange} checked={isCheck} />;

    function onChange() {
      params.data.isNotify = !isCheck;
      setIsCheck(!isCheck);

      const newLimit = [...userAlertLimit];
      const target = newLimit.find(e => e.ticker === params.data.trading_code && e.exchange === params.data.exchange);
      if (target) {
        target.isNotify = !isCheck;
      } else {
        newLimit.push({
          ticker: params.data.trading_code,
          exchange: params.data.exchange,
          country: exchangeCountryMap[params.data.exchange],
          isNotify: !isCheck,
          upperAlert: oc(params.data).upperAlert(""),
          upperWarning: oc(params.data).upperWarning(""),
          lowerWarning: oc(params.data).lowerWarning(""),
          lowerAlert: oc(params.data).lowerAlert(""),
          bidAlert: oc(params.data).bidAlert(""),
          askAlert: oc(params.data).askAlert("")
        });
      }
      updateAlertLimit(newLimit);
    }
  };
};
